import { Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { DeliveryNoteStatusEnum, DeliveryNoteType } from "@altertec_gparn/lib";
import { toEuros } from "@/utils/numberUtils";
import { UserDto } from "@/core/features/users/user.dto";
import { PurchaseOrderDto } from "@/core/features/purchase-orders/purchase-order.dto";
import { DeliveryNoteLineDto } from "@/core/features/delivery-notes/delivery-note-line.dto";
import { FileDto } from "@/core/features/file/file.dto";

export class DeliveryNoteDto extends BaseEntityDto {
  code: string;

  status?: DeliveryNoteStatusEnum;

  @Type(() => PurchaseOrderDto)
  purchaseOrders: PurchaseOrderDto[];

  @Transform(({ value }) => toEuros(value))
  totalAmount: number;

  @Type(() => DeliveryNoteLineDto)
  lines: DeliveryNoteLineDto[];

  @Type(() => FileDto)
  files: FileDto[];

  @Type(() => UserDto)
  createdBy: UserDto;

  @Transform(({ value }) => new Date(value))
  date: Date;

  isReturn: boolean;

  @Type(() => DeliveryNoteDto)
  originDeliveryNote?: DeliveryNoteDto;
  originDeliveryNoteId?: string;

  sapDocNum?: number | null;
  sapDocSeriesName?: string | null;
  sapSyncError?: string | null;

  isEditable() {
    return this.status === DeliveryNoteStatusEnum.DRAFT;
  }

  isDeletable() {
    return this.status === DeliveryNoteStatusEnum.DRAFT;
  }

  get type() {
    return this.originDeliveryNoteId ? DeliveryNoteType.RETURN : DeliveryNoteType.NORMAL;
  }

  toString(): string {
    return this.code;
  }
}
